import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    fetch: (config: AxiosRequestConfig) => api.get(`/location/ingredients`, config),
};

export default requests;
